import React from 'react'
import { Link } from 'react-router-dom'
import constants from '../../constants'
import _ from 'lodash'
import SizeSelector from 'app/components/size_selector'

class SizeBox extends React.Component {
  constructor(props) {
    super(props);
    this.slug = constants.GROUP_TYPES.SIZE.SIZE;
    this.group = 'size';
  }

  get sizes() {
    if (!this.props.sizes) { return []; }

    return this.props.sizes.map((size) => {
      return (
        <SizeSelector key={size.id}
                      value={size.value}
                      item={size}
                      onSizeSelected={this.props.sizeSelected}
                      selectedSizes={this.props.orderState[this.group].items}
        />
      );
    });
  }

  handleClick = (e) => {
    this.props.onGroupSelected(this.group, this.slug);
  };

  render() {
    return (
      <div
        className={`wizard-block-form selectable-block ${this.props.orderState[this.group].selected == this.slug ? 'selected' : ''}`}
        onClick={this.handleClick}
      >
        <div className='selectable-block-indicator'></div>
        <div className='selectable-block-title'>Заводской стандарт</div>
        <div className='form selects-'>
          <div className='form-row inline- two-cols- inputs- buttons-'>
            { this.sizes }
          </div>
        </div>
      </div>
    );
  }
}

export default SizeBox;



// WEBPACK FOOTER //
// ./app/javascript/app/components/size_box/index.jsx